var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7638_15722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.46 20.9711C15.9828 20.9711 20.46 16.4939 20.46 10.9711C20.46 5.44822 15.9828 0.971069 10.46 0.971069C4.93711 0.971069 0.459961 5.44822 0.459961 10.9711C0.459961 16.4939 4.93711 20.9711 10.46 20.9711Z",
    fill: "#CB3050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66829 6.6001H14.7683C15.808 6.6001 16.6578 7.41394 16.7152 8.43945L16.7183 8.5501V14.2501C16.7183 15.2899 15.9044 16.1396 14.8789 16.197L14.7683 16.2001H6.66829C5.62844 16.2001 4.77871 15.3862 4.72135 14.3607L4.71826 14.2501V8.5501C4.71826 7.51028 5.53213 6.66055 6.55763 6.60318L6.66829 6.6001ZM15.8182 9.82388L10.9279 12.3983C10.8154 12.4575 10.6841 12.4659 10.5663 12.4237L10.5087 12.3983L5.61826 9.8245V14.2501C5.61826 14.801 6.04253 15.2528 6.58214 15.2966L6.66829 15.3001H14.7683C15.3191 15.3001 15.771 14.8758 15.8148 14.3362L15.8182 14.2501V9.82388ZM14.7683 7.50009H6.66829C6.11737 7.50009 5.66555 7.92438 5.62174 8.46395L5.61826 8.5501V8.80751L10.7183 11.4916L15.8182 8.80689V8.5501C15.8182 7.99918 15.394 7.54737 14.8544 7.50355L14.7683 7.50009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7638_15722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.459961 0.971069)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRed);
export default __webpack_public_path__ + "static/media/email_red.608812bb07273b3af0e037a8ad4650b1.svg";
export { ForwardRef as ReactComponent };